import { render } from "./box-sizing.md?vue&type=template&id=be21ed82"
const script = {}
script.render = render

export default script